import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TAnnualFeeTypeDetails } from 'redux/reducers/easFee/types';

export const tableStructure: TTableStructure<keyof TAnnualFeeTypeDetails>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Name',
		selector: 'name',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Description',
		selector: 'description',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 3,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		tooltip: (item) => item.description ?? '',
	},
	{
		name: 'Name For Invoice',
		selector: 'nameForInvoice',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Value',
		selector: 'value',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Threshold',
		selector: 'threshold',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Included Amount',
		selector: 'includedAmount',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
			{
				name: 'Delete',
				icon: EIconButtons.DELETE,
			},
		],
	},
];
